<!-- Left selection bar outside two handles -->
<span
	ngCustomizableSliderElement
	#leftOuterSelectionBar
	class="customizable-slider-span customizable-slider-bar-wrapper customizable-slider-left-out-selection"
>
	<span class="customizable-slider-span customizable-slider-bar"></span>
</span>

<!-- Right selection bar outside two handles -->
<span
	ngCustomizableSliderElement
	#rightOuterSelectionBar
	class="customizable-slider-span customizable-slider-bar-wrapper customizable-slider-right-out-selection"
>
	<span class="customizable-slider-span customizable-slider-bar"></span>
</span>

<!-- The whole slider bar -->
<span
	ngCustomizableSliderElement
	#fullBar
	[class.customizable-slider-transparent]="fullBarTransparentClass"
	class="customizable-slider-span customizable-slider-bar-wrapper customizable-slider-full-bar"
>
	<span class="customizable-slider-span customizable-slider-bar"></span>
</span>

<!-- Selection bar between two handles -->
<span
	ngCustomizableSliderElement
	#selectionBar
	[class.customizable-slider-draggable]="selectionBarDraggableClass"
	class="customizable-slider-span customizable-slider-bar-wrapper customizable-slider-selection-bar"
>
	<!-- eslint-disable-next-line @angular-eslint/template/no-inline-styles -->
	<span
		class="customizable-slider-span customizable-slider-bar customizable-slider-selection"
		[ngStyle]="barStyle"
	></span>
</span>

<!-- Low slider handle -->
<!-- eslint-disable-next-line @angular-eslint/template/no-inline-styles -->
<span
	ngCustomizableSliderHandle
	#minHandle
	class="customizable-slider-span customizable-slider-pointer customizable-slider-pointer-min"
	[ngStyle]="minPointerStyle"
></span>

<!-- High slider handle -->
<!-- eslint-disable-next-line @angular-eslint/template/no-inline-styles -->
<span
	ngCustomizableSliderHandle
	#maxHandle
	[style.display]="range ? 'inherit' : 'none'"
	class="customizable-slider-span customizable-slider-pointer customizable-slider-pointer-max"
	[ngStyle]="maxPointerStyle"
></span>

<!-- Floor label -->
<span
	ngCustomizableSliderLabel
	#floorLabel
	class="customizable-slider-span customizable-slider-bubble customizable-slider-limit customizable-slider-floor"
></span>

<!-- Ceiling label -->
<span
	ngCustomizableSliderLabel
	#ceilLabel
	class="customizable-slider-span customizable-slider-bubble customizable-slider-limit customizable-slider-ceil"
></span>

<!-- Label above the low slider handle -->
<span
	ngCustomizableSliderLabel
	#minHandleLabel
	class="customizable-slider-span customizable-slider-bubble customizable-slider-model-value"
></span>

<!-- Label above the high slider handle -->
<span
	ngCustomizableSliderLabel
	#maxHandleLabel
	class="customizable-slider-span customizable-slider-bubble customizable-slider-model-high"
></span>

<!-- Combined range label when the slider handles are close ex. 15 - 17 -->
<span
	ngCustomizableSliderLabel
	#combinedLabel
	class="customizable-slider-span customizable-slider-bubble customizable-slider-combined"
></span>

<!-- The ticks -->
<span
	ngCustomizableSliderElement
	#ticksElement
	[hidden]="!showTicks"
	[class.customizable-slider-ticks-values-under]="ticksUnderValuesClass"
	class="customizable-slider-ticks"
>
	<!-- eslint-disable-next-line @angular-eslint/template/no-inline-styles -->
	<span
		*ngFor="let t of ticks"
		class="customizable-slider-tick"
		[ngClass]="{ 'customizable-slider-selected': t.selected }"
		[ngStyle]="t.style"
	>
		<ng-customizable-slider-tooltip-wrapper
			[template]="tooltipTemplate"
			[tooltip]="t.tooltip"
			[placement]="t.tooltipPlacement"
		></ng-customizable-slider-tooltip-wrapper>
		<ng-customizable-slider-tooltip-wrapper
			*ngIf="t.value !== null"
			class="customizable-slider-span customizable-slider-tick-value"
			[template]="tooltipTemplate"
			[tooltip]="t.valueTooltip"
			[placement]="t.valueTooltipPlacement"
			[content]="t.value"
		></ng-customizable-slider-tooltip-wrapper>
		<span
			*ngIf="t.legend !== null"
			class="customizable-slider-span customizable-slider-tick-legend"
			[innerHTML]="t.legend"
		></span>
	</span>
</span>
